/**
 * Какие remotes развёрнуты в этой инсталляции.
 *
 * Хост собирается со статическим списком из 23 remotes, но у клиента с
 * урезанным набором сервисов часть из них не существует. Признак —
 * переменная `VITE_*_MFE_URL`, заданная ПУСТОЙ строкой при сборке: такой
 * remote не тянется и его пункт меню не показывается. Незаданная переменная
 * (локальная разработка) и непустой URL — remote включён, как раньше.
 */
export const isRemoteEnabled = (url: string | undefined): boolean => url !== '';

/** Пункт меню → переменная remote, который этот раздел показывает. */
export const MENU_REMOTE_ENV: Record<string, string> = {
  'reports-new': 'VITE_DASHBOARDS_DATA_PREP_MFE_URL',
  superset: 'VITE_SUPERSET_URL',
  'org-chart': 'VITE_ORGSTRUCTURE_MFE_URL',
  'doc-constructor': 'VITE_DOCUMENTS_CONSTRUCTOR_MFE_URL',
  tax: 'VITE_TAX_MFE_URL',
  rules: 'VITE_RULES_MFE_URL',
  payroll: 'VITE_PAYROLL_MFE_URL',
  'int-invoices': 'VITE_INT_INVOICES_MFE_URL',
  'bank-accounts': 'VITE_BANK_ACCOUNTS_MFE_URL',
  kanban: 'VITE_KANBAN_MFE_URL',
  arm: 'VITE_ARM_MFE_URL',
  'data-sources': 'VITE_INTEGRATION_HUB_MFE_URL',
  'aggregator-service': 'VITE_AGGREGATOR_SERVICE_MFE_URL',
  integrations: 'VITE_N8N_CONFIGS_MFE_URL',
  'files-recognition': 'VITE_FILES_RECOGNITION_MFE_URL',
  'email-file-extractor': 'VITE_EMAIL_FILE_EXTRACTOR_MFE_URL',
};

export function enabledMenuItems<T extends { id: string }>(
  items: T[],
  env: Record<string, string | undefined>,
): T[] {
  return items.filter((item) => {
    const key = MENU_REMOTE_ENV[item.id];
    return !key || isRemoteEnabled(env[key]);
  });
}

/**
 * Стартовая страница инсталляции.
 *
 * Раздел «Отчёты» (`/reports`) собирается из трёх витрин данных, и у клиента
 * с урезанным набором сервисов их нет — вход заканчивался пустой страницей.
 * Адрес берётся из `VITE_DEFAULT_ROUTE`; не задан или пуст — прежний `/reports`.
 */
export const DEFAULT_ROUTE_FALLBACK = '/reports';

export function defaultRoute(env: Record<string, string | undefined>): string {
  const value = (env.VITE_DEFAULT_ROUTE ?? '').trim();
  if (!value) return DEFAULT_ROUTE_FALLBACK;
  return value.startsWith('/') ? value : `/${value}`;
}
